import PropTypes from 'prop-types'
import React from 'react'
import {colors, media} from '../styles'
import {css} from 'glamor'

const style = {
  button: css({
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    border: 'none',
    height: '100%',
    margin: 0,
    padding: 0,
    textIndent: '-999px',
    width: '100%',
    '&:focus': {
      outline: 'none',
      borderColor: colors.primaryBG
    }
  }),
  color: css({
    border: `3px solid ${colors.white}`,
    borderRadius: '50%',
    boxShadow: `0 0 0 1px ${colors.headingText}`,
    display: 'inline-block',
    height: '25px',
    margin: '6px',
    overflow: 'hidden',
    width: '25px',
    fontSize: '12px',
    lineHeight: '14px',
    ...media.mobile({
      height: '40px',
      width: '40px'
    })
  }),
  colorActive: css({
    boxShadow: `0 0 0 2px ${colors.defaultText}`
  }),
  colorSelector: css({
    listStyle: 'none',
    padding: 0,
    ...media.mobile({
      marginLeft: '-15px',
      marginRight: '-15px',
      overflowX: 'scroll',
      padding: '4px 19px',
      whiteSpace: 'nowrap'
    }),
    ...media.md({
      margin: '0 auto',
      textAlign: 'center'
    }),
    ...media.lg({
      margin: '0 auto'
    })
  })
}

const ColorSelector = ({
  imageServerHost,
  options,
  onChange,
  value,
  storageObjects,
  newImageServer
}) => {
  if (newImageServer) {
    return (
      <ul {...style.colorSelector}>
        {options.map((option) => {
          let colorStyle = style.color
          if (option.SanitizedColorName === value) {
            colorStyle = css(colorStyle, style.colorActive)
          }

          return (
            <li key={option.Color} {...colorStyle}>
              <button
                className="colorButton"
                onClick={onChange}
                value={option.SanitizedColorName}
                {...css(
                  {
                    backgroundImage: `url(${storageObjects.productStorageObjects}${option.SKU}/${option.SanitizedColorName}_sw.jpg)`
                  },
                  style.button
                )}>
                {option.Color}
              </button>
            </li>
          )
        })}
      </ul>
    )
  } else {
    return (
      <ul {...style.colorSelector}>
        {options.map((option) => {
          let colorStyle = style.color
          if (option.SanitizedColorName === value) {
            colorStyle = css(colorStyle, style.colorActive)
          }
          return (
            <li key={option.Color} {...colorStyle}>
              <button
                className="colorButton"
                onClick={onChange}
                value={option.SanitizedColorName}
                {...css(
                  {
                    backgroundImage: `url(${imageServerHost}/ProductImages/${option.SKU}/${option.SanitizedColorName}_sw.jpg)`
                  },
                  style.button
                )}>
                {option.Color}
              </button>
            </li>
          )
        })}
      </ul>
    )
  }
}

ColorSelector.propTypes = {
  imageServerHost: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  storageObjects: PropTypes.object.isRequired,
  newImageServer: PropTypes.string
}

export default ColorSelector
